// Candle
// Features:
// - Physical candle object that can be interacted with
// - Toggles flame visual state on click

import { useEffect } from 'react'
import { RigidBody } from '@react-three/rapier'

import { useStore } from '../../store/useStore'
import CandleFlame from './CandleFlame'

export default function Candle({ nodes, physicsMaterial }) {
    // Interaction: Click to toggle candle
    useEffect(() => {
        const onMouseDown = (e) => {
            if (e.button !== 0) return
            const state = useStore.getState()
            if (state.currentHitName === 'Candle' && state.isPointerLocked) {
                state.toggleCandle()
            }
        }

        window.addEventListener('mousedown', onMouseDown)
        return () => window.removeEventListener('mousedown', onMouseDown)
    }, [])

    return (
        <group>
            <RigidBody
                colliders="trimesh"
                type="fixed"
                userData={{ name: 'Candle' }}
                position={[-2.598, 2.426, 1.568]}
            >
                <mesh
                    geometry={nodes.light_candle_physics.geometry}
                    material={physicsMaterial}
                />
            </RigidBody>

            <CandleFlame position={[-2.598, 2.71, 1.568]} />
        </group>
    )
}
